import {
  COVERAGE_GROUP_COMPANIES_SET_LOADING,
  COVERAGE_GROUP_COMPANIES_SET_ERROR,
  COVERAGE_GROUP_COMPANIES_SET_COVERAGE_GROUP_COMPANIES,
  COVERAGE_GROUP_COMPANIES_SET_PAGINATION,
  COVERAGE_GROUP_COMPANIES_FETCH_COVERAGE_GROUP_COMPANIES,
  COVERAGE_GROUP_COMPANIES_CLEAR_ERROR,
  COVERAGE_GROUP_COMPANIES_GET_COVERAGE_GROUP_COMPANIES,
  COVERAGE_GROUP_COMPANIES_GET_PAGINATION,
  COVERAGE_GROUP_COMPANIES_GET_LOADING,
  COVERAGE_GROUP_COMPANIES_GET_ERROR
} from './types';
import { coverageGroupCompanyService } from '@/network';
import {
  handleAsyncAction,
  createAsyncState,
  createAsyncMutations
} from '@/utils/helpers/store';

const state = {
  coverageGroupCompanies: [],
  pagination: {
    page: 1,
    pages: null,
    size: 10,
    count: 0
  },
  ...createAsyncState(['fetchCoverageGroupCompanies'])
};

const mutations = {
  ...createAsyncMutations(
    COVERAGE_GROUP_COMPANIES_SET_LOADING,
    COVERAGE_GROUP_COMPANIES_SET_ERROR
  ),
  [COVERAGE_GROUP_COMPANIES_SET_COVERAGE_GROUP_COMPANIES](
    state,
    coverageGroupCompanies
  ) {
    state.coverageGroupCompanies = coverageGroupCompanies;
  },
  [COVERAGE_GROUP_COMPANIES_SET_PAGINATION](state, pagination) {
    state.pagination = pagination;
  }
};

const actions = {
  async [COVERAGE_GROUP_COMPANIES_FETCH_COVERAGE_GROUP_COMPANIES](
    { commit },
    { companyIds, policyId, groupCompanyId, page, size }
  ) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchCoverageGroupCompanies',
      errorMessage: 'Ocurrió un error al obtener las coberturas',
      asyncOperation: async () => {
        const hasPagination = size > 0;

        const query = {
          companyIds,
          policyId,
          groupCompanyId
        };

        let coverageGroupCompanies;
        if (hasPagination) {
          const { rows, ...pagination } =
            await coverageGroupCompanyService.findAll({
              ...query,
              page,
              size
            });
          coverageGroupCompanies = rows;
          commit(COVERAGE_GROUP_COMPANIES_SET_PAGINATION, pagination);
        } else {
          coverageGroupCompanies = await coverageGroupCompanyService.findAll({
            ...query
          });
        }
        commit(
          COVERAGE_GROUP_COMPANIES_SET_COVERAGE_GROUP_COMPANIES,
          coverageGroupCompanies
        );
        return coverageGroupCompanies;
      },
      setLoading: COVERAGE_GROUP_COMPANIES_SET_LOADING,
      setError: COVERAGE_GROUP_COMPANIES_SET_ERROR
    });
  },

  [COVERAGE_GROUP_COMPANIES_CLEAR_ERROR]({ commit }, { type }) {
    commit(COVERAGE_GROUP_COMPANIES_SET_ERROR, {
      type,
      value: null
    });
  }
};

const getters = {
  [COVERAGE_GROUP_COMPANIES_GET_COVERAGE_GROUP_COMPANIES]: (state) =>
    state.coverageGroupCompanies,
  [COVERAGE_GROUP_COMPANIES_GET_PAGINATION]: (state) => state.pagination,
  [COVERAGE_GROUP_COMPANIES_GET_LOADING]: (state) => state.loading,
  [COVERAGE_GROUP_COMPANIES_GET_ERROR]: (state) => state.error
};

export default {
  state,
  mutations,
  actions,
  getters
};
